import React, { useCallback, useEffect, useState } from 'react';
import { ChevronIcon, CloseIcon, ExpandIcon } from '../../components/icons';
import { SCREENSHOTS } from './content';

export default function Gallery() {
  const [openIndex, setOpenIndex] = useState(null);
  const isOpen = openIndex !== null;

  const step = useCallback((offset) => {
    setOpenIndex((current) => (current + offset + SCREENSHOTS.length) % SCREENSHOTS.length);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpenIndex(null);
      if (event.key === 'ArrowRight') step(1);
      if (event.key === 'ArrowLeft') step(-1);
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, step]);

  return (
    <>
      <ul className="gallery">
        {SCREENSHOTS.map((shot, index) => (
          <li key={shot.src} className={index === 0 ? 'gallery__item gallery__item--wide' : 'gallery__item'}>
            <button type="button" onClick={() => setOpenIndex(index)}>
              <img src={shot.src} alt={shot.alt} loading="lazy" width="1440" height="810" />
              <span className="gallery__zoom" aria-hidden="true">
                <ExpandIcon />
              </span>
              <span className="visually-hidden">Open larger view</span>
            </button>
          </li>
        ))}
      </ul>

      {isOpen && (
        <div
          className="lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Screenshot viewer"
          onClick={() => setOpenIndex(null)}
        >
          <button
            type="button"
            className="lightbox__close"
            aria-label="Close"
            onClick={() => setOpenIndex(null)}
          >
            <CloseIcon />
          </button>
          <button
            type="button"
            className="lightbox__step lightbox__step--prev"
            aria-label="Previous screenshot"
            onClick={(event) => {
              event.stopPropagation();
              step(-1);
            }}
          >
            <ChevronIcon width="24" height="24" />
          </button>
          <button
            type="button"
            className="lightbox__step lightbox__step--next"
            aria-label="Next screenshot"
            onClick={(event) => {
              event.stopPropagation();
              step(1);
            }}
          >
            <ChevronIcon width="24" height="24" />
          </button>
          <figure className="lightbox__figure" onClick={(event) => event.stopPropagation()}>
            <img src={SCREENSHOTS[openIndex].src} alt={SCREENSHOTS[openIndex].alt} />
            <figcaption>
              {SCREENSHOTS[openIndex].alt}
              <span>{`${openIndex + 1} / ${SCREENSHOTS.length}`}</span>
            </figcaption>
          </figure>
        </div>
      )}
    </>
  );
}
